import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  BookOpen, 
  FileText,
  Users, 
  Receipt, 
  LogOut,
  ChevronRight,
  Image,
  Video,
  Info,
  PhoneCall
} from 'lucide-react';
import '../../styles/admin/AdminSidebar.css';

const navItems = [
  { label: 'Dashboard', to: '/admin', icon: LayoutDashboard, end: true },
  { label: 'Programs', to: '/admin/programs', icon: BookOpen },
  { label: 'Program Content', to: '/admin/program-content', icon: BookOpen },
  { label: 'Forms', to: '/admin/forms', icon: FileText },
  { label: 'About Page', to: '/admin/about', icon: Info },
  { label: 'Contact Page', to: '/admin/contact', icon: PhoneCall },
  { label: 'Banners', to: '/admin/banners', icon: Image },
  { label: 'Video Gallery', to: '/admin/videos', icon: Video },
  { label: 'Blogs', to: '/admin/blogs', icon: FileText },
  { label: 'Users', to: '/admin/users', icon: Users },
  { label: 'Transactions', to: '/admin/transactions', icon: Receipt },
];

export function AdminSidebar({ user, onLogout }) {
  const location = useLocation();

  return (
    <aside className="admin-sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <img 
          src="/assets/logo-img.jpg" 
          alt="GFWD" 
          className="sidebar-logo-img"
        />
        <span className="logo-text">GFWD</span>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {navItems.map(({ label, to, icon: Icon, end }) => {
          const isActive = end 
            ? location.pathname === to 
            : location.pathname.startsWith(to);
          
          return (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={`nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon className={`nav-icon ${isActive ? 'active' : ''}`} />
              <span className="nav-label">{label}</span>
              {isActive && <ChevronRight className="nav-chevron" />}
            </NavLink>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <div className="user-info">
          <p className="user-email">{user?.email}</p>
          <p className="user-role">Administrator</p>
        </div>
        <button className="logout-btn" onClick={onLogout}>
          <LogOut className="h-4 w-4" />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
}

export default AdminSidebar;
